import React, { useEffect, useState } from "react";

import { Row, Typography, Col, Divider, Card, Table, Button } from "antd";
import { BicepsFlexed, Gauge, TrendingUpDown } from "lucide-react";

import { FONT } from "constants/index";

import { notificationInfo } from "util/api-utils";
import { ColumnsLastReview } from "./columns-table";
import { chartLiner } from "../reviews/reviews-drawer-charts";
import ExempleCycle from "./planning-drawer-exemple-cycle";
import DrawerApp from "components/drawer-app";
import useBreakpoint from "hooks/useBreakpoint";
import { drawerWidth } from "util/responsive";

const { Text } = Typography;
const columsExemple = [
  {
    title: "Ciclo",
    dataIndex: "cycle",
    textWrap: "word-break",
    ellipsis: true,
    width: "30%",
  },
  {
    title: "VMP Mínima (m/s)",
    dataIndex: "vmpMin",
    textWrap: "word-break",
    ellipsis: true,
    width: "30%",
  },
  {
    title: "VMP Máxima (m/s)",
    dataIndex: "vmpMax",
    textWrap: "word-break",
    ellipsis: true,
    width: "30%",
  },
];
const FormNewUserPlanningBackSquad = (props) => {
  const { isMobile, width } = useBreakpoint();
  const [review, setReview] = useState(null);
  const [openExemple, setOpenExemple] = useState(false);

  useEffect(() => {
    setReview(props.review);
  }, [props]);

  function getlastReview() {
    if (review?.actualReview == null) {
      return [];
    }

    const absoluteStrengthList = [
      review.actualReview.load1,
      review.actualReview.load2,
      review.actualReview.load3,
      review.actualReview.load4,
      review.actualReview.load5,
      review.actualReview.load6,
    ].filter((item) => item !== null);
    const vmp = [
      review.actualReview.vmp1,
      review.actualReview.vmp2,
      review.actualReview.vmp3,
      review.actualReview.vmp4,
      review.actualReview.vmp5,
      review.actualReview.vmp6,
    ].filter((item) => item !== null);

    if (absoluteStrengthList.length == 0 && props.user?.id != null) {
      notificationInfo("Aluno sem avaliação!");
    }

    const response = [];
    const absoluteStrength = review?.actualReview?.absoluteStrength;
    absoluteStrengthList.forEach((item, index) => {
      const rm = ((item * 100) / absoluteStrength).toFixed(2);
      response.push({
        absoluteStrength: item,
        vmp: vmp[index],
        rm: rm,
      });
    });
    return response;
  }
  function mountPrediction() {
    if (
      review?.actualReview == null ||
      review?.actualReview.slope == null ||
      review?.actualReview?.intercept == null
    ) {
      return [];
    }
    const absoluteStrength = review?.actualReview?.absoluteStrength;
    const slope = review?.actualReview?.slope;
    const intercept = review?.actualReview?.intercept;

    const response = [];
    var valueInitial = 30;
    for (let index = 0; index < 15; index++) {
      const abValue = ((valueInitial * absoluteStrength) / 100).toFixed(0);
      const vmp = (slope * valueInitial + intercept).toFixed(2);
      response.push({
        absoluteStrength: abValue,
        vmp: vmp,
        rm: valueInitial,
      });
      valueInitial += 5;
    }
    return response;
  }
  function chartVMP() {
    const lastReview = getlastReview();
    const vmp = [];

    vmp.push({
      load: Math.ceil(lastReview[0]?.rm - 5) + "%",

      vmpActual: null,
      vmpComparation: null,
    });
    var lastValue = Math.ceil(lastReview[0]?.rm - 5);
    lastReview.forEach((item) => {
      vmp.push({
        load: Math.ceil(item.rm) + "%",
        vmpActual: item.vmp,
        vmpComparation: null,
      });
      lastValue = Math.ceil(item.rm);
    });
    vmp.push({
      load: Math.ceil(lastValue + 5) + "%",
      vmpActual: null,
      vmpComparation: null,
    });
    return vmp;
  }
  const showDrawer = () => {
    setOpenExemple(true);
  };
  return (
    <>
      <Divider />
      <Card
        id="card-table"
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flex: 1 }}>
              <BicepsFlexed
                size={18}
                style={{ marginBottom: "-4px", marginRight: "10px" }}
              />
              <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                Última Avaliação
              </Text>
            </div>
          </div>
        }
        bordered={false}
      >
        <Table
          columns={ColumnsLastReview()}
          dataSource={getlastReview()}
          pagination={false}
          size="small"
          locale={{
            emptyText: "Sem registro",
          }}
                  scroll={{ x: "max-content" }}
        />
      </Card>
      <Row gutter={16} style={{ marginTop: "15px" }}>
        <Col span={24} style={{ textAlign: "left" }}>
          <Text
            style={{
              fontSize: "15px",
              fontFamily: FONT,
            }}
          >
            Força Absoluta:
          </Text>
          <Text
            style={{
              fontSize: "15px",
              fontFamily: FONT,
              fontWeight: "bold",
            }}
          >
            {review?.actualReview?.absoluteStrength &&
              " " + review?.actualReview?.absoluteStrength + "  KG"}
          </Text>
        </Col>
      </Row>
      <Divider />
      <Row gutter={16} style={{ marginTop: "15px" }}>
        <Col span={isMobile ? 24 : 12} style={{ marginTop: "10px" }}>
          <Card
            title={
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ flex: 1 }}>
                  <Gauge
                    size={18}
                    style={{ marginBottom: "-4px", marginRight: "10px" }}
                  />
                  <Text style={{ fontSize: "14px", fontFamily: FONT }}>
                    VMP = [{review?.actualReview?.slope}x +{" "}
                    {review?.actualReview?.intercept}]
                  </Text>
                </div>
              </div>
            }
            style={{ width: "100%" }}
          >
            {chartLiner(
              chartVMP(),
              "load",
              "vmpActual",
              "vmpComparation",
              "vmp",
              "vmp Comparação",
              10
            )}
          </Card>
        </Col>
        <Col span={isMobile ? 24 : 12} style={{ marginTop: "10px" }}>
          <Card
            id="card-table"
            title={
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ flex: 1 }}>
                  <TrendingUpDown
                    size={18}
                    style={{ marginBottom: "-4px", marginRight: "10px" }}
                  />
                  <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                    Valores de Predição
                  </Text>
                </div>
              </div>
            }
            bordered={false}
          >
            <Table
              columns={ColumnsLastReview()}
              dataSource={mountPrediction()}
              pagination={false}
              size="small"
              locale={{
                emptyText: "Sem registro",
              }}
              scroll={{
                y: 413,
              }}
            />
          </Card>
        </Col>
      </Row>
      <Row style={{ margin: 30 }} justify="end">
        <Button
          style={{
            fontFamily: FONT,
            background: "#14B8A6",
            color: "#ffffff",
          }}
          onClick={() => showDrawer(true)}
        >
          Ciclos de Exemplo
        </Button>
      </Row>
      <DrawerApp
        open={openExemple}
        onClose={() => setOpenExemple(false)}
        title={"Ciclos de Exemplo"}
        body={
          <>
            <ExempleCycle
              title={"Etapa 1"}
              columns={columsExemple}
              data={[
                { cycle: "1.0", vmpMin: "1.39", vmpMax: "1.24" },
                { cycle: "2.0", vmpMin: "1.32", vmpMax: "1.08" },
                { cycle: "3.0", vmpMin: "1.32", vmpMax: "1.08" },
                { cycle: "4.0", vmpMin: "1.32", vmpMax: "1.05" },
                { cycle: "5.0", vmpMin: "1.32", vmpMax: "1.05" },
                { cycle: "6.0", vmpMin: "1.24", vmpMax: "1.01" },
                { cycle: "7.0", vmpMin: "1.24", vmpMax: "1.01" },
              ]}
            />
            <ExempleCycle
              title={"Etapa 2"}
              columns={columsExemple}
              data={[
                { cycle: "1.0", vmpMin: "1.21", vmpMax: "1.01" },
                { cycle: "2.0", vmpMin: "1.21", vmpMax: "0.92" },
                { cycle: "3.0", vmpMin: "1.21", vmpMax: "0.92" },
                { cycle: "4.0", vmpMin: "1.08", vmpMax: "0.92" },
                { cycle: "5.0", vmpMin: "1.08", vmpMax: "0.92" },
                { cycle: "6.0", vmpMin: "1.08", vmpMax: "0.84" },
                { cycle: "7.0", vmpMin: "1.08", vmpMax: "0.84" },
              ]}
            />
            <ExempleCycle
              title={"Etapa 3"}
              columns={columsExemple}
              data={[
                { cycle: "1.0", vmpMin: "1.08", vmpMax: "0.84" },
                { cycle: "2.0", vmpMin: "1.08", vmpMax: "0.84" },
                { cycle: "3.0", vmpMin: "1.08", vmpMax: "0.84" },
                { cycle: "4.0", vmpMin: "1.01", vmpMax: "0.76" },
                { cycle: "5.0", vmpMin: "1.01", vmpMax: "0.76" },
                { cycle: "6.0", vmpMin: "1.01", vmpMax: "0.68" },
                { cycle: "7.0", vmpMin: "1.01", vmpMax: "0.68" },
              ]}
            />
          </>
        }
        size={"large"}
        isOnlyView={true}
        width={drawerWidth(isMobile, 60)}
      />
    </>
  );
};
export default FormNewUserPlanningBackSquad;
